module.exports = __webpack_public_path__ + "static/media/found2.ced7f720.png";